module.exports = require("fs");


//////////////////
// WEBPACK FOOTER
// external "fs"
// module id = 27
// module chunks = 0